<template>
  <div>
  <div class="container seg-content general user">
    <section class="home-list">
      <router-link class="new-button" :to="{name: 'content.postedit', params: {id: 'new-video'}}">Add New Video</router-link>
      
      <post-list type="video" />
    </section>

    
    

    
  </div>
  </div>
</template>
<script>
export default {
  data: ()=>({
    menuOpen: false,
  }),
  methods: {
    toggleMenu() {
      this.menuOpen=!this.menuOpen;
      if (!this.menuOpen)
        this.$refs.mobileMenu.menuSubOpen=null;
    },
    action($event) {
      var actionName="action"+($event.name[0].toUpperCase())+($event.name.substring(1));
      
      this[actionName] && this[actionName]($event);
    },
  },
}
</script>
